import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import Tooltip from 'components/tooltip';

const DEFAULT_SIZE = 36;

const SIZE_MAP = {
    'xxlarge': 94,
    'xlarge': 72,
    'large': 55,
    'medium': 30,
    'small': 24,
    'xsmall': 20,
    'xxsmall': 16,
    'xxxsmall': 14,
};

const AvatarBase = ({ size, empty, solidImage, border, dimmed, image, className, text, showStatus, online, color, secondaryColor, onClick, children }) =>  {
    const { t } = useTranslation('user');

    const style = useMemo(() => {
        if (image) {
            return null;
        }

        if (secondaryColor) {
            return {
                backgroundImage: `linear-gradient(180deg, ${color} 0%, ${secondaryColor} 100%)`
            }
        }

        return {
            backgroundColor: color
        }
    }, [image, color, secondaryColor]);

    const avatarClassName = useMemo(() => {
        const result = ['avatar'];

        if (size) result.push(size);
        if (empty) result.push('empty');
        if (solidImage) result.push('solid-image');
        if (border) result.push('border');
        if (dimmed) result.push('dimmed');
        if (image) result.push('has-image');
        if (!image) result.push('no-image');
        if (onClick) result.push('clickable');
        if (className) result.push(className);

        return result.join(' ');
    }, [size, empty, solidImage, border, dimmed, image, className]);

    const sizeInPx = useMemo(() => {
        try {
            return (SIZE_MAP[size] || DEFAULT_SIZE) * (window.devicePixelRatio > 1 ? 2 : 1);
        } catch (e) {
            return DEFAULT_SIZE;
        }
    }, [size]);

    const optimizedImage = useMemo(() => {
        if (!image) {
            return null;
        }

        if (typeof image === 'string' && image.indexOf('https://niftypm-production-assets-user.s3-accelerate.amazonaws.com') === 0) {
            return image
                .replace('https://niftypm-production-assets-user.s3-accelerate.amazonaws.com', 'https://edge.niftypm.com') + `?tr=w-${sizeInPx},h-${sizeInPx}`
        }

        return image;
    }, [image, sizeInPx]);

    return (
        <span
            className={avatarClassName}
            style={style}
            onClick={onClick}
        >
            {
                image ? (
                    <img className="avatar-image" src={encodeURI(decodeURIComponent(optimizedImage))} />
                ) : null
            }

            { text }

            { children }

            {
                showStatus ? (
                    <Tooltip tooltip={(online ? t('states.active') : t('states.away'))}>
                        <span className={'status-indicator' + (online ? ' active' : ' inactive')} />
                    </Tooltip>
                ) : null
            }
        </span>
    )
}

export default AvatarBase;
